export const validateDataTableStyle = {
	tableContainer: {
		maxHeight: 'calc(100vh - 400px)',
		border: '1px solid var(--neutral-100)',
		padding: '12px',
		borderRadius: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
		maxWidth: '1074px',
	},

	btnWrapper: {
		display: 'flex',
		gap: '12px',
	},

	tableHead: {
		background: 'var(--default-white) !important',
		fontSize: '14px !important',
		color: 'var(--neutral-900) !important',
		padding: '10px 4px !important',
	},

	title: {
		fontWeight: 'bold',
	},

	switch: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
		whitespace: 'nowrap',
	},

	text: {
		whitespace: 'nowrap',
		width: '200px',
	},

	wrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: '16px',
		width: '1074px',
	},

	tableCell: {
		padding: '10px 4px !important',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		maxWidth: '112px !important',

		'&:last-child': {
			width: '60px',
		},
	},

	tableRow: {
		display: 'flex !important',
		gap: '4px !important',
	},

	buttonWrapper: {
		display: 'flex',
		alignItems: 'center',
		position: 'fixed',
		gap: '24px',
		bottom: '24px',
		maxWidth: '1170px',
		width: '100%',
		height: '80px',
		padding: '0 100px',
		background: 'var(--neutral-100)',
		left: 'calc(50% - 585px)',
		borderRadius: '0 0 8px 8px',
	},

	button: {
		height: '44px',
		fontWeight: 700,

		'&.MuiButton-outlinePrimary': {
			backgroundColor: 'var(--neutral-100)',

			'&:hover': {
				backgroundColor: 'var(--primary-100)',
				color: 'var(--primary-500)',
			},
		},
	},

	errorIcon: {
		path: {
			fill: 'var(--error-500)',
		},
	},

	warningIcon: {
		width: '100%',
		height: '100%',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 20px',
			width: '100%',

			'& > div': {
				width: '100%',
				maxWidth: '370px',
				margin: '0 auto',

				'&> div svg path': {
					fill: 'var(--warning-500)',
				},
			},
		},
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
	},
};
